import { render, staticRenderFns } from "./WinnerBig.vue?vue&type=template&id=c19c1736&scoped=true&"
import script from "./WinnerBig.vue?vue&type=script&lang=js&"
export * from "./WinnerBig.vue?vue&type=script&lang=js&"
import style0 from "./WinnerBig.vue?vue&type=style&index=0&id=c19c1736&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19c1736",
  null
  
)

export default component.exports